import { AssessorAssignmentsDto } from './assessor-assignments.dto';

export class AssessorAssignments {
    readonly organisationIds: string[];
    readonly schoolIds: string[];
    readonly courseIds: string[];
    readonly packageIds: string[];

    constructor(dto: AssessorAssignmentsDto) {
        this.organisationIds = dto.organisationIds ?? [];
        this.schoolIds = dto.schoolIds ?? [];
        this.courseIds = dto.courseIds ?? [];
        this.packageIds = dto.packageIds ?? [];
    }
}
